//@ts-check
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/features/auth/AuthContext.jsx';
import { defaultHomePath } from '@/lib/nav.js';
import { hasPermission, isAdmin } from '@/lib/permissions.js';

/**
 * Restricts a route to admin and/or a permission.
 * @param {{ adminOnly?: boolean, permission?: 'record'|'view'|'download'|'share' }} props
 */
export function RoleRoute({ adminOnly = false, permission }) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin(user)) {
    return <Navigate to={defaultHomePath(user)} replace />;
  }

  if (permission && !hasPermission(user, permission)) {
    return <Navigate to={defaultHomePath(user)} replace />;
  }

  return <Outlet />;
}
